/* NEXCAPE Shop-Chat — Widget (Dennis-Auftrag 02.08.2026)
   Selbstgebaut statt Fremd-App: nur so gelten unsere Claim-Grenzen (Abriebschutz statt
   Dichtheits-Claim) auch im Chat.

   WICHTIG — warum die Adresse nicht fest im Code steht:
   Das Backend haengt an einem cloudflared-Tunnel, dessen URL sich bei jedem Neustart
   aendert. Eine fest eingetragene Adresse waere nach dem naechsten Stromausfall tot, und
   zwar sichtbar fuer Kunden. Deshalb holt das Widget die aktuelle Adresse aus der
   Nachbardatei nexcape-chat-endpoint.json (gleicher Asset-Ordner) — die schreibt der
   Waechter automatisch neu. Faellt die Datei ODER das Backend aus, erscheint der Chat
   erst gar nicht (statt als kaputter Knopf dazustehen). */
(function () {
  if (window.__nxChat) return;
  window.__nxChat = 1;

  var self = document.currentScript && document.currentScript.src;
  if (!self) return;
  // 🔴 CACHE-STEMPEL PFLICHT: Shopifys CDN liefert ein Asset ohne Versions-Parameter
  // dauerhaft aus dem Edge-Cache aus. Ohne den Zeitstempel bekam der Browser noch die
  // ALTE Tunnel-Adresse, waehrend im Theme laengst die neue stand — der Waechter heilte,
  // und niemand sah es (gemessen 02.08.2026). `cache: no-store` hilft dagegen NICHT,
  // das betrifft nur den Browser-Cache, nicht den Edge.
  var confUrl = self.replace(/nexcape-chat\.js.*$/, 'nexcape-chat-endpoint.json')
                    + '?t=' + Math.floor(Date.now() / 60000);   // pro Minute frisch

  var CSS = ''
    + '#nxc-b{position:fixed;right:18px;bottom:18px;z-index:2147483000;width:56px;height:56px;'
    + 'border-radius:50%;background:#14182a;color:#fff;border:none;cursor:pointer;font-size:24px;'
    + 'box-shadow:0 6px 22px rgba(0,0,0,.28)}'
    + '#nxc-b:hover{background:#f63032}'
    + '#nxc-p{position:fixed;right:18px;bottom:84px;z-index:2147483000;width:352px;max-width:calc(100vw - 28px);'
    + 'height:472px;max-height:calc(100vh - 120px);background:#fff;border-radius:14px;display:none;'
    + 'flex-direction:column;overflow:hidden;box-shadow:0 10px 40px rgba(0,0,0,.3);'
    + 'font:15px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:#14182a}'
    + '#nxc-p.on{display:flex}'
    + '#nxc-h{background:#14182a;color:#fff;padding:12px 14px;font-weight:600;display:flex;'
    + 'justify-content:space-between;align-items:center}'
    + '#nxc-h span{font-size:12px;font-weight:400;opacity:.75}'
    + '#nxc-x{background:none;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1}'
    + '#nxc-m{flex:1;overflow-y:auto;padding:12px 14px;background:#f7f8fa}'
    + '.nxc-a,.nxc-u{margin:0 0 10px;padding:9px 12px;border-radius:12px;max-width:86%;white-space:pre-wrap;'
    + 'overflow-wrap:anywhere}'
    + '.nxc-a{background:#fff;border:1px solid #e6e8ee}'
    + '.nxc-u{background:#14182a;color:#fff;margin-left:auto}'
    + '#nxc-f{display:flex;border-top:1px solid #e6e8ee;background:#fff}'
    + '#nxc-i{flex:1;border:none;padding:13px 14px;font-size:15px;outline:none;font-family:inherit}'
    + '#nxc-s{border:none;background:#f63032;color:#fff;padding:0 17px;cursor:pointer;font-size:15px}'
    + '#nxc-s:disabled{background:#c3c6cf;cursor:default}'
    + '#nxc-n{font-size:11px;color:#7a8296;padding:7px 14px;background:#fff;border-top:1px solid #eef0f4}';

  function el(t, a) { var e = document.createElement(t); for (var k in a) e[k] = a[k]; return e; }

  function bauen(endpunkt) {
    var st = el('style'); st.textContent = CSS; document.head.appendChild(st);

    var knopf = el('button', { id: 'nxc-b', innerHTML: '&#128172;', title: 'Fragen? KI-Beratung öffnen' });
    knopf.setAttribute('aria-label', 'KI-Beratung öffnen');
    var panel = el('div', { id: 'nxc-p' });
    panel.innerHTML =
      '<div id=nxc-h><div>NEXCAPE KI-Beratung<br><span>Automatischer Assistent &middot; kein Mitarbeiter</span></div>'
      + '<button id=nxc-x aria-label=Schließen>&times;</button></div>'
      + '<div id=nxc-m></div>'
      + '<div id=nxc-f><input id=nxc-i placeholder="Ihre Frage ..." autocomplete=off>'
      + '<button id=nxc-s>Senden</button></div>'
      + '<div id=nxc-n>KI-generierte Antworten. Zu Bestellungen und Preisen meldet sich das '
      + 'Team persönlich: support@nexcape.de</div>';
    document.body.appendChild(knopf); document.body.appendChild(panel);

    var mBox = panel.querySelector('#nxc-m'), inp = panel.querySelector('#nxc-i'),
        snd = panel.querySelector('#nxc-s');
    var verlauf = [], offen = false;

    function zeile(cls, text) {
      var d = el('div', { className: cls, textContent: text });
      mBox.appendChild(d); mBox.scrollTop = mBox.scrollHeight; return d;
    }

    function auf() {
      offen = !offen; panel.classList.toggle('on', offen);
      if (offen) {
        if (!mBox.children.length) {
          // Art. 50 Abs. 1 KI-VO (gilt ab 02.08.2026): Wer mit einem KI-System
          // interagiert, muss das wissen — spaetestens bei der ERSTEN Interaktion,
          // klar und eindeutig (Abs. 5). Darum steht es im ersten Satz und im Kopf,
          // nicht im Kleingedruckten.
          zeile('nxc-a', 'Hallo! Ich bin der KI-Assistent von NEXCAPE — kein Mensch, '
            + 'sondern ein automatischer Berater. Ich helfe bei Fragen zu unseren Produkten, '
            + 'etwa zu Passform, Material, Maßen oder Versand. '
            + 'Bei Bestellungen und Preisen übernimmt das Team persönlich.');
        }
        setTimeout(function () { inp.focus(); }, 60);
      }
    }
    knopf.onclick = auf;
    panel.querySelector('#nxc-x').onclick = auf;

    function senden() {
      var t = inp.value.trim(); if (!t) return;
      inp.value = ''; zeile('nxc-u', t);
      snd.disabled = true;
      var warte = zeile('nxc-a', '...');
      fetch(endpunkt.replace(/\/$/, '') + '/chat', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: t, history: verlauf.slice(-6), page: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (d) {
        warte.textContent = d.answer || 'Da ist mir gerade etwas dazwischengekommen — '
          + 'schreiben Sie uns bitte kurz an support@nexcape.de.';
        verlauf.push(['u', t]); verlauf.push(['a', warte.textContent]);
      }).catch(function () {
        warte.textContent = 'Ich bin gerade nicht erreichbar. Schreiben Sie uns bitte an '
          + 'support@nexcape.de, dann melden wir uns.';
      }).then(function () {
        snd.disabled = false; inp.focus(); mBox.scrollTop = mBox.scrollHeight;
      });
    }
    snd.onclick = senden;
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') senden(); });
  }

  // Erst pruefen, ob das Backend ueberhaupt lebt. Ein Chat-Knopf, der ins Leere klickt,
  // ist schlechter als gar kein Chat-Knopf.
  // Adresse kommt bevorzugt aus dem server-gerenderten Snippet (window.NXC_ENDPOINT).
  // Die JSON-Datei bleibt nur als Rueckfalloption stehen — sie haengt hinter dem CDN und
  // kann veraltet sein (02.08.2026 genau daran gescheitert).
  function pruefeUndBaue(endpunkt) {
    if (!endpunkt) return Promise.reject();
    return fetch(endpunkt.replace(/\/$/, '') + '/health', { cache: 'no-store' })
      .then(function (h) { if (!h.ok) throw 0; return h.text(); })
      .then(function (t) { if (t.indexOf('shop-chat') === -1) throw 0; bauen(endpunkt); });
  }

  pruefeUndBaue(window.NXC_ENDPOINT)
    .catch(function () {
      return fetch(confUrl, { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { return pruefeUndBaue(c && c.endpoint); });
    })
    .catch(function () { /* still: kein Backend -> kein Widget */ });
})();

